import createVueApp from '@phoenix/createVueApp';
import FocusSections from '@maison/components/organisms/FocusSections';

document.querySelectorAll('.phoenix-focus-sections').forEach((el) => {
  const app = createVueApp();
  app.component('FocusSections', FocusSections);
  app.mount(el);
});
